<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="bookVehicle" [hidden]="spinner">
  <header class="bookVehicle--header" id="top">
    <div class="bookVehicle--header__container">
      <h4 class="bookVehicle--header__title">{{ 'requestBook' | i18next }}</h4>
      <div #stepperHeader></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="'bookVehicle'"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
